import Vue from "vue";
import Router from "vue-router";

import Login from "@/components/Login";
import EmptyRouterView from "@/components/EmptyRouterView";
import Home from "@/components/Home";
import UsersTable from "@/components/user/UsersTable";
import CompetitionsList from "@/components/competitions/CompetitionsList";
import CreateCompetition from "@/components/competitions/CreateCompetition";
import EditCompetition from "@/components/competitions/EditCompetition";
import TeamsTable from "@/components/competitions/schemes/TeamsTable";
import SchemaSelect from "@/components/competitions/schemes/SchemaSelect";
import LicenseList from "@/components/license/LicenseList";
import ClubList from "@/components/club/ClubList";
import TeamForm from "@/components/team/TeamForm";

import Brackets from "@/components/competitions/brackets/Brackets";

import VuejsDialog from "vuejs-dialog";
// include the default style
import "vuejs-dialog/dist/vuejs-dialog.min.css";

Vue.use(VuejsDialog);

Vue.use(Router);

const router = new Router({
  routes: [
    { path: "*", component: Home },
    {
      path: "/",
      component: EmptyRouterView,
      meta: {
        requiresAuth: true,
        title: "monitor"
      },
      children: [
        {
          name: "Home",
          path: "",
          component: Home
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: "/clubs",
      component: EmptyRouterView,
      meta: {
        title: "clubs",
        requiresAuth: true
      },
      children: [
        {
          name: "ClubList",
          path: "/",
          component: ClubList,
          meta: {
            title: "clubs",
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/licenses",
      component: EmptyRouterView,
      meta: {
        title: "licenses",
        requiresAuth: true
      },
      children: [
        {
          name: "LicenseList",
          path: "/",
          component: LicenseList,
          meta: {
            title: "licenses",

            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/users",
      component: EmptyRouterView,
      meta: {
        title: "users",

        requiresAuth: true
      },
      children: [
        {
          name: "UsersTable",
          path: "/",

          component: UsersTable,
          meta: {
            title: "users",
            requiresAuth: true
          }
        }
      ]
    },
    {
      path: "/competitions",
      component: EmptyRouterView,
      meta: {
        title: "competitions",
        requiresAuth: true
      },
      children: [

        {
          name: "CompetitionsList",
          path: "/",
          component: CompetitionsList,
          meta: {
            title: "competitions",
            requiresAuth: true
          }
        },
        {
          name: "TeamForm",
          path: "/competition/:id/team",
          component: TeamForm,
          meta: {
            title: "team",
            requiresAuth: true
          }
        },
        {
          name: "TeamEditForm",
          path: "/competition/:id/team/:clubId",
          component: TeamForm,
          meta: {
            title: "team",
            requiresAuth: true
          }
        },
        {
          name: "CreateCompetition",
          path: "/create-competition",
          component: CreateCompetition,
          meta: {
            title: "create-competition",
            requiresAuth: true
          }
        },
        {
          name: "TeamsTable",
          path: "/competition/:id/teams-table",
          component: TeamsTable,
          meta: {
            title: "teams-table",
            requiresAuth: true
          }
        },
        {
          name: 'CreateCompetition',
          path: '/create-competition',
          component: CreateCompetition,
          meta: {
            title: 'create-competition',
            requiresAuth: true
          }
        },
        {
          name: 'SchemaSelect',
          path: '/competition/:id/:cat/schema',
          component: SchemaSelect,
          meta: {
            title: 'schema',
            requiresAuth: true
          }
        },
        {
          name: 'EditCompetition',
          path: '/edit-competition/:id',
          component: EditCompetition,
          meta: {
            title: 'edit-competition',
            requiresAuth: true
          }
        },


        {
          name: 'Brackets',
          path: '/competition/brackets/:id/:cat',
          component: Brackets,
          meta: {
            title: 'brackets',
            requiresAuth: true
          }
        },

      ]
    },
  ]
});
let checkAuth = (to, from) => {
  let returnBool = true;
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt") == null) {
      returnBool = false;
    }
  }
  return returnBool;
};

router.beforeEach((to, from, next) => {
  let isAuth = checkAuth(to, from);
  if (!isAuth) {
    return next({
      path: "/login"
    });
  }
  return next();
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js